import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
const THEMES = ["light", "dark", "hc"];

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem("mp_theme") || "light");
  const [largeText, setLargeTextState] = useState(() => localStorage.getItem("mp_large_text") === "true");

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark", "hc");
    if (theme === "dark") root.classList.add("dark");
    if (theme === "hc") root.classList.add("hc");
    localStorage.setItem("mp_theme", theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.classList.toggle("text-lg-mode", largeText);
    localStorage.setItem("mp_large_text", String(largeText));
  }, [largeText]);

  const setTheme = (t) => THEMES.includes(t) && setThemeState(t);
  const cycleTheme = () => setThemeState((t) => THEMES[(THEMES.indexOf(t) + 1) % THEMES.length]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, cycleTheme, largeText, setLargeText: setLargeTextState }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
